import {defineBrand, type Suggestion} from '@livingdata/playground-core-front'
import {LivingDataLogo} from './logo'

// The two suggestions that present the agent are read first, for a visitor who
// has no question yet: onboarding, which starts from what their work involves,
// then what the agent can do. The concrete demonstrations follow, for whoever
// is ready to ask.
const suggestions: Suggestion[] = [
  {id: 'onboarding', i18nKey: 'suggestions.onboarding', icon: 'compass'},
  {id: 'capabilities', i18nKey: 'suggestions.capabilities', icon: 'wand'},
  {id: 'mapAddresses', i18nKey: 'suggestions.mapAddresses', icon: 'map'},
  {id: 'exploreDataset', i18nKey: 'suggestions.exploreDataset', icon: 'lightbulb'}
]

export const brand = defineBrand({
  name: 'Living Data Studio',
  Logo: LivingDataLogo,
  suggestions
})
